export const SearchCardDefProps = {
  linkTo: '/',
  title: 'Search Card Title',
  underTitle: 'Search card under title text',
  formattedMatchedParams: [
    {name: 'First matched param', value: '12345678789'},
    {name: 'Second matched param', value: '12345678789'}
  ],
  formattedTags: ['tag1', 'tag2']
};